import * as types from './constants';

const initialState = {
  data: {},
  getLoading: false,
  errors_api: {}
};

const actions = {
  // Get Account
  [types.GET_STRIPE_BILLING_REQUEST]: state => {
    const data = {
      ...state,
      getLoading: true
    };

    return { ...data };
  },

  [types.GET_STRIPE_BILLING_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      getLoading: false,
      data: payload
    };

    return { ...data };
  },

  [types.GET_STRIPE_BILLING_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      getLoading: false,
      errors_api: payload
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};